/**
 * Order Details
 */

// React
import React, { useState, useEffect, useContext } from 'react';

// Context
import AuthContext from '../../authContext';

//UI
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import theme from '../../theme';
import {
  Dialog,
  DialogContent,
  Typography,
  DialogActions,
  Paper,
  Grid,
  Button,
  Divider,
  CircularProgress,
  Radio,
  RadioGroup,
  Select,
  FormControl,
  FormControlLabel,
  IconButton,
  DialogTitle,
  TextField,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiCalendar,
  mdiStateMachine,
  mdiAccountOutline,
  mdiArrowRight,
  mdiPencilOutline,
  mdiClose,
  mdiPhoneOutline,
  mdiCalendarClock,
  mdiMapMarkerOutline,
  mdiPrinter,
  mdiCounter,
  mdiPlus,
  mdiSelectionMarker,
  mdiChevronLeft,
  mdiCheck,
  mdiBarcodeScan,
  mdiPackageVariant,
  mdiLabel,
  mdiReceipt,
} from '@mdi/js';

// Components
import ListOrderItems from './list';
import Can from '../../components/Can';

// Rules
import {
  rulesAdminChangeOrderStatus,
  rulesOrderStatus,
} from '../../utils/rulesOrderStatus';

// Helper
import {
  translate,
  formaterPhoneNumber,
  removeEmptyValueObject,
} from '../../utils/helpers';
import jMoment from 'moment-jalaali';

// Type
import { Status } from '../orders/interfaces';
import { SelectorProps, Props, Item } from './interfaces';
import { Link, useHistory } from 'react-router-dom';
import OrderItemDetail from './orderItemDetail';
import OrderInventoryItems from './orderInventoryItems';
import Modal from '../../components/Modal';
import { warehouseZoneUnits } from '../warehouseZone-unit/interfaces';
import handleNotfication from '../../utils/handleNotification';

import handleError from '../../utils/handleError';
import ordersRepository from 'client-sdk/src/Repository/orders-repository';
import warehouseUnitRepository from 'client-sdk/src/Repository/warehouse-unit-repository';
import inventoryItemsRepository from 'client-sdk/src/Repository/inventory-items-repository';
import orderItemsRepository from 'client-sdk/src/Repository/order-items.repository';
import { useForm } from 'react-hook-form';
import showDeliveryType from '../../utils/temporaryConditions/showDeliveryType';
import showOrderTplType from '../../utils/temporaryConditions/showOrderTplType';
import getOrderFileReq from 'client-sdk/src/orders/files';
// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        '@media (max-width: 768px)': {
          margin: theme.spacing(0),
        },
      },
    },
    paper: {
      marginTop: '36px',
      marginBottom: '36px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: '1px solid #ddd',
      borderRadius: '4px',
      '@media (max-width: 768px)': {
        padding: theme.spacing(0),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        backgroundColor: theme.palette.background.default,
      },
    },
    addIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: '#5c5c5c',
      },
    },
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    rtlIcon: {
      marginRight: theme.spacing(1),
      transform: 'scale(-1, 1)',
    },
    divider: {
      width: '98%',
      margin: '10px auto',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '10px',
    },
    headerBox: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '28px',
    },
    contentlabelTitle: {
      position: 'relative',
      color: theme.palette.gray.light,
      marginLeft: '40px',
      fontSize: '14px',
      fontWeight: 500,
      '&:before': {
        content: '"-"',
        position: 'absolute',
        left: '-20px',
      },
    },
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'justify',
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.error.main,
      },
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    detail: {
      backgroundColor: 'white',
      padding: '5px',
      width: '100%',
    },
  })
);

export function Details(props: Props) {
  const history = useHistory();
  const authContext = useContext(AuthContext);
  const { register, handleSubmit, setValue, getValues } = useForm({});
  const [previewState, setPreviewState] = useState('PICKED' as Status);
  const [openUnitItems, setOpenUnitItems] = useState(false as boolean);
  const [openBarcodeScan, setOpenBarcodeScan] = useState(false as boolean);
  const [barcodeSerial, setBarcodeSerial] = useState('');
  const [serialNumber, setSerialNumber] = useState(false);
  const [openDeleteInventoryItem, setOpenDeleteInventoryItem] = useState(
    false as boolean
  );
  const [updateInventoryItem, setUpdateInventoryItem] = useState(
    false as boolean
  );
  const [updateOrderItem, setUpdateOrderItem] = useState(false as boolean);
  const [updateInventoryItemsWithSerial, setUpdateInventoryItemsWithSerial] =
    useState(false as boolean);
  const [updateItems, setUpdateItems] = useState(false as boolean);
  const [openPickItems, setOpenPickItems] = useState(false as boolean);
  const [openBarcode, setOpenBarcode] = useState(false as boolean);
  const [searchMode, setSearchMode] = useState("serial")
  const [unit, setUnit] = useState({} as warehouseZoneUnits);
  const [id, setId] = useState(-1 as number);
  const [inventoryItem, setInventoryItem] = useState({} as any);
  const [orderItem, setOrderItem] = useState({} as Item);
  const [openConfirmUpdateState, setOpenConfirmUpdateState] = useState(
    false as boolean
  );
  const [filtersValues, setFiltersValues] = useState({
    page: 0,
    size: 10,
  } as any);
  const [units, setUnits] = useState([]);
  const [order, setOrder] = useState({});
  const [count, setCount] = useState<number>(0);
  const [inventoryItems, setInventoryItems] = useState([]);
  const [inventoryItemsWithSerial, setInventoryItemsWithSerial] = useState([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>('');
  const [errorModal, setErrorModal] = useState<boolean>(false);
  const classes = useStyles();

  const orderWithId = async (id: any) => {
    const payload = { id };
    try {
      setLoading(true);
      const response = await ordersRepository.getOrderWithId({ payload });
      setOrder(response.data);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    order?.status === 'PICKED' && history.push('/warehouse-operator-orders');
  }, [order]);

  useEffect(() => {
    const { id } = props.match.params;
    orderWithId(id);
  }, []);
  const updateOrderStatus = async (action: any) => {
    const payload = { ...action };
    try {
      setLoading(true);
      const { pagination, callback } = await ordersRepository.updateOrderStatus({
        payload,
      });
      callback && callback();
      handleNotfication('تغییر وضعیت سفارش با موفقیت انجام شد', 'success');
    } catch (error) {
      setError(error.message);
      handleNotfication('تغییر وضعیت سفارش انجام نشد', 'error');
    } finally {
      setLoading(false);
    }
  };
  const changeStatusOrder = () => {
    const { id } = props.match.params;
    updateOrderStatus({
      id: order.id,
      body: {
        status: previewState.replace(/"/g, ''),
      },
      pagination: {},
      callback: () => window.history.back(),
    });
    handleClose();
  };

  const locateItem = (inventoryItem: any) => {
    setInventoryItem(inventoryItem);
    setOpenDeleteInventoryItem(true);
  };
  const deleteInventoryItemFromOrderItems = async (action: any) => {
    const payload = { ...action };
    try {
      setLoading(true);
      const callback =
        await inventoryItemsRepository.deleteInventoryItemFromOrderItem({
          payload,
        });
      handleNotfication('تغییر وضعیت آیتم انبار با موفقیت انجام شد', 'success');
      callback && callback();
    } catch (error) {
      setError(error.message);
      handleNotfication('تغییر وضعیت آیتم انبار انجام نشد', 'error');
    } finally {
      setLoading(false);
    }
  };
  const deleteInventoryItemFromOrderItem = () => {
    const { id } = props.match.params;
    deleteInventoryItemFromOrderItems({
      id: inventoryItem.id,
      pagination: {},
      callback: () => {
        handleCloseDialog();
        orderWithId(id);
      },
    });
  };

  const handleOpenConfirmUpdateState = (body: Status) => {
    setOpenConfirmUpdateState(true);
    setPreviewState(body);
  };

  const handleChangeStatus = (orderItem: Item) => {
    setId(orderItem.variantId);
    setOrderItem(orderItem);
    getWarehouseZoneUnitAction(orderItem.variantId);
    setOpenPickItems(true);
  };

  const getInventoryItemsWithSerialFunc = (serial: string) => {
    setBarcodeSerial(serial);
    getInventoryItemsWithSerialActionFunc(serial);
  };
  const getInventoryItemsWithSerial = async (action: any) => {
    const payload = { ...action };
    try {
      setLoading(true);
      const { response, callback } =
        await inventoryItemsRepository.getAllInventoryItemsWithSerial({
          payload,
        });
      setInventoryItemsWithSerial(response.data.content);
      callback && callback();
    } catch (error) {
      setError(error.message);
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };
  const getInventoryItemsWithSerialActionFunc = (serial: string) => {
    const { page, size } = filtersValues;
    getInventoryItemsWithSerial({
      ...removeEmptyValueObject(filtersValues),
      serialNumber: { equals: serial },
      page,
      size,
      callback: () => {
        setUpdateInventoryItemsWithSerial(!updateInventoryItemsWithSerial);
        setSerialNumber(!serialNumber);
      },
    });
  };

  useEffect(() => {
    if (inventoryItemsWithSerial.length === 0 && openPickItems) {
      handleNotfication('آیتمی با سریال مورد نظر پیدا نشد', 'error');
    }
  }, [inventoryItemsWithSerial]);

  const pickItem = (unit: warehouseZoneUnits) => {
    setUnit(unit);
    setOpenPickItems(true);
    getInventoryItemsAction(id, unit.id);
  };
  const warehouseZoneUnit = async (action: any) => {
    const payload = { ...action };
    try {
      setLoading(true);
      const { response, count } =
        await warehouseUnitRepository.getWarehouseZoneUnit({ payload });
      setUnits(response.data);
      setCount(count.data);
    } catch (error) {
      setError(error.message);
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };
  const getWarehouseZoneUnitAction = (id: number) => {
    const { page } = filtersValues;
    warehouseZoneUnit({
      ...removeEmptyValueObject(filtersValues),
      skuId: { equals: id },
      page,
      size: 500,
    });
  };
  const getInventoryItems = async (action: any) => {
    const payload = { action };
    try {
      setLoading(true);
      const { response, callback } =
        await inventoryItemsRepository.getInventoryItems({ payload });
      setInventoryItems(response.data.content);
      callback && callback();
    } catch (error) {
      setError(error.message);
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };
  const getInventoryItemsAction = (id: any, unitId: number) => {
    const { page } = filtersValues;
    getInventoryItems({
      ...removeEmptyValueObject(filtersValues),
      skuId: { equals: id },
      unitId: { equals: unitId },
      status: { in: 'LOCATED,PICKED' },
      page,
      size: 500,
      callback: () => {
        setUpdateItems(true);
      },
    });
  };

  const handleUpdateInventoryItems = (item: any) => {
    updateInventoryItems(item.id);
  };
  const assignInventoryItemToOrderItem = async (action: any) => {
    const payload = { ...action };
    try {
      setLoading(true);
      const callback =
        await inventoryItemsRepository.assignInventoryItemToOrderItem({
          payload,
        });
      handleNotfication('تغییر وضعیت آیتم انبار با موفقیت انجام شد', 'success');
      callback && callback();
    } catch (error) {
      setError(error.message);
      if (
        error.status === 400 &&
        error.message ===
        'inventory item and order item does not belong to same sku'
      ) {
        handleNotfication('آیتم انبار با آیتم سفارش مطابقت ندارد', 'error');
      } else {
        handleNotfication('تغییر وضعیت آیتم انبار انجام نشد', 'error');
      }
    } finally {
      setLoading(false);
    }
  };
  const updateInventoryItems = (id: number) => {
    assignInventoryItemToOrderItem({
      ...removeEmptyValueObject(filtersValues),
      id: id,
      body: `"${orderItem.id}"`,
      callback: () => {
        setOpenBarcodeScan(false);
        setUpdateInventoryItem(!updateInventoryItem);
      },
    });
  };

  const updateOrderItems = () => {
    setOpenPickItems(false);
    getWarehouseZoneUnitAction(id);
    setUpdateOrderItem(!updateOrderItem);
  };

  useEffect(() => {
    if (order.items) {
      let amountOfItems = [];
      for (const item of order.items) {
        if (
          item.amount !==
          item.inventoryItems.reduce((a, b: any) => a + (b['amount'] || 0), 0)
        ) {
          amountOfItems.push(item);
        }
      }
      amountOfItems.length === 0 && setOpenPickItems(false);
    }
  }, [updateOrderItem, order]);

  useEffect(() => {
    if (barcodeSerial) {
      if (inventoryItemsWithSerial[0]?.id) {
        handleUpdateInventoryItems(inventoryItemsWithSerial[0]);
      }
    }
  }, [updateInventoryItemsWithSerial]);

  useEffect(() => {
    if (id !== -1) getInventoryItemsAction(id, unit.id);
  }, [updateInventoryItem]);

  useEffect(() => {
    const { id } = props.match.params;
    if (orderItem.id) orderWithId(id);
  }, [updateOrderItem]);

  useEffect(() => {
    if(order?.items?.filter(item => item.status !== 'PICKED').length === 0) {
      changeStatusOrder()
    }
  }, [order])

  const handleClose = () => {
    setOpenConfirmUpdateState(false);
  };

  const handleCloseDialog = () => {
    setOpenDeleteInventoryItem(false);
  };
  const handleCloseErrorDialog = () => {
    setErrorModal(false);
  };

  const handleCloseUnitModal = () => {
    setOpenUnitItems(false);
  };

  const handleClosePickModal = () => {
    setOpenPickItems(false);
  };

  const onSubmit = (data: any) => {
    const { id } = props.match.params;
    if(searchMode === "serial") {
      updateInventoryItemOrderItem(id, data.serial);
      setValue('serial', '');
    }else {
      updateOrderItemWithCode(data.code, id)
      setValue('code', '');
    }
  };

  const updateOrderItemWithCode = async (code:string, orderId:number) => {
    try {
      await orderItemsRepository.updateInventoryItemWithCode({
        payload: {params: {'productCode.equals': code, order_id: orderId}},
      });
      orderWithId(orderId);
      handleNotfication('آیتم برداشته شد', 'success');
    } catch (error) {
      // handleNotfication('آیتم برداشته نشد', 'error');
      setErrorModal(true);
    }
  }

  const updateInventoryItemOrderItem = async (orderId: number,serial: string) => {
    const payload = { id: serial, body: orderId };
    try {
      await orderItemsRepository.updateInventoryItemOrderItem({
        payload,
      });
      orderWithId(orderId);
      handleNotfication('آیتم برداشته شد', 'success');
    } catch (error) {
      // handleNotfication('آیتم برداشته نشد', 'error');
      setErrorModal(true);
    }
  };
  const getOrderFile = async (type: string) => {
    try {
      const response = await getOrderFileReq(order.id, { fileType: type })
      const file = URL.createObjectURL(response.blob)
      return file;
    } catch (error: any) {
      handleError(error)
      return error;
    }
  }

  const downLoadFile = async (type: string, fileName: string) => {
    try {
      const file = await getOrderFile(type);
      const link = document.createElement('a');
      link.href = file;
      link.setAttribute(
        'download',
        fileName,
      );
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);

    } catch (error: any) {
      //   handleError(error)
    }
  }
  return (
    <div className={classes.root}>
      <div className={classes.headerBox}>
        <Typography variant="h6" component="h2">
          {`
        جزيیات سفارش
     
        `}
        </Typography>
        <span className={classes.contentlabelTitle}>{order.id}</span>
      </div>

      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Button
          aria-label="details"
          size="medium"
          onClick={() => window.history.back()}
        >
          <Icon path={mdiArrowRight} size={1} className={classes.icon} />
          {'بازگشت'}
        </Button>
        <Link
          to={`/orders/exit-receipts/${order.id}`}
          target="_blank"
          style={{
            textDecoration: 'none',
            margin: '0px 10px',
          }}
        >
          <Button
            variant="contained"
            color="secondary"
            startIcon={<Icon path={mdiReceipt} size={1} />}
          >
            {'چاپ رسید خروج'}
          </Button>
        </Link>
      </Grid>
      <Paper elevation={3} className={classes.paper} variant="elevation" square>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiAccountOutline}
                  size={1}
                  className={classes.icon}
                />
                {'نام تحویل گیرنده:  '}
              </span>

              <span>{order.customerName}</span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiPhoneOutline}
                  size={1}
                  className={classes.rtlIcon}
                />
                {'نام شرکت:  '}
              </span>
              <span>{order.partnerName}</span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiCounter} size={1} />
                {'تعداد آیتم های سفارش:  '}
              </span>
              <span>{order?.items?.length}</span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiCalendar} size={1} className={classes.icon} />
                {'زمان تحویل سفارش:  '}
              </span>
              <span>
                {order.deliveryDate &&
                  `${jMoment(order.deliveryDate, 'YYYY/MM/DD')
                    .locale('fa')
                    .format('jYYYY/jMM/jDD')}`}
              </span>
              <span style={{ padding: '0 10px' }}>-</span>
              <span>
                {order.deliveryStartTime &&
                  order.deliveryEndTime &&
                  `${jMoment(order.deliveryStartTime, 'hh:mm:ss')
                    .locale('fa')
                    .format('HH:mm')} تا 
                ${jMoment(order.deliveryEndTime, 'hh:mm:ss')
                    .locale('fa')
                    .format('HH:mm')}`}
              </span>
            </div>
          </Grid>
          <Divider className={classes.divider} />
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiStateMachine}
                  size={1}
                  className={classes.icon}
                />
                {'وضعیت تحویل :  '}
              </span>
              <Can
                role={authContext.user.role}
                perform="orders:changeOrderStatus"
                yes={() => (
                  <FormControl style={{ width: '50%' }}>
                    <Icon
                      path={mdiPencilOutline}
                      size={1}
                      className={classes.changStatusIcon}
                    />
                    <Select
                      className={classes.changStatusBox}
                      fullWidth
                      inputProps={{
                        name: 'name',
                        id: 'uncontrolled-native',
                      }}
                      name={'status'}
                      id={order.rubikaId}
                      value={[{}]}
                      IconComponent={() => null}
                      renderValue={() => (
                        <span className={classes.renderValue}>
                          {translate(order.status, 'order')}
                        </span>
                      )}
                    >
                      <RadioGroup
                        className={classes.radioGroup}
                        aria-label={'status'}
                        name={'status$'}
                        value={'item'}
                        onChange={(
                          e: React.ChangeEvent<{
                            value: unknown;
                          }>
                        ) =>
                          handleOpenConfirmUpdateState(
                            `"${e.target.value}"` as Status
                          )
                        }
                      >
                        {rulesOrderStatus[order.status]?.map(
                          (item: any, index: number) => (
                            <FormControlLabel
                              className={classes.radioGroupItem}
                              key={index}
                              checked={order.status === item}
                              value={item}
                              disabled={
                                rulesAdminChangeOrderStatus[
                                  authContext.user.role
                                ].indexOf(item) === -1
                              }
                              control={<Radio />}
                              label={translate(item, 'order')}
                            />
                          )
                        )}
                      </RadioGroup>
                    </Select>
                  </FormControl>
                )}
                no={() => <span>{translate(order.status, 'order')}</span>}
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                {/* <Icon path={mdiCalendar} size={1} className={classes.icon} /> */}
                {'کد پیگیری سفارش:  '}
              </span>
              <span>
                {order.trackingCode}
              </span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                {/* <Icon path={mdiCalendar} size={1} className={classes.icon} /> */}
                {'نوع پردازش:  '}
              </span>
              <span>
                {showDeliveryType(order.deliveryType)}
              </span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                {/* <Icon path={mdiCalendar} size={1} className={classes.icon} /> */}
                {'ناوگان حمل:  '}
              </span>
              <span>
                {showOrderTplType(order.deliveryType, order.orderTplType)}
              </span>
            </div>
          </Grid>
          <Divider className={classes.divider} />

          <Grid item xs={12}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiMapMarkerOutline}
                  size={1}
                  className={classes.icon}
                />
                {'آدرس سفارش‌دهنده:  '}
              </span>
              <span>{order.customerAddress && order.customerAddress}</span>
            </div>
          </Grid>
        </Grid>
      </Paper>
      <Grid container spacing={3} alignItems="center">
        <Grid item xs={3} alignItems="center">
          {order.receiptUrl && (
            <a
              href={`${order.receiptUrl}`}
              target="_blank"
              style={{ textDecoration: 'none', marginLeft: '10px' }}
            >
              <Button
                variant="contained"
                color="secondary"
                startIcon={<Icon path={mdiPrinter} size={1} />}
              >
                {'چاپ فاکتور سفارش'}
              </Button>
            </a>
          )}
          {order.fulfillmentAttachmentUrl && (
            <a
              href={`${order.fulfillmentAttachmentUrl}`}
              target="_blank"
              style={{ textDecoration: 'none' }}
            >
              <Button
                variant="contained"
                color="secondary"
                startIcon={<Icon path={mdiLabel} size={1} />}
              >
                {'چاپ لیبل های سفارش'}
              </Button>
            </a>
          )}
          {order.receiptFileName && order?.status !== 'CANCELLED' && (
            <Button
              variant="contained"
              color="secondary"
              startIcon={<Icon path={mdiPrinter} size={1} />}
              onClick={() => downLoadFile("RECEIPT", order.receiptFileName)}
            >
              دانلود فایل فاکتور
            </Button>
          )}
          {order.labelFileName && order?.status !== 'CANCELLED' && (
            <Button
              variant="contained"
              color="secondary"
              startIcon={<Icon path={mdiLabel} size={1} />}
              onClick={() => downLoadFile("LABEL", order.labelFileName)}
            >
              دانلود فایل لیبل
            </Button>
          )}
        </Grid>
        <Grid item xs={9}>
          <form
            style={{ width: '320px', marginRight: 'auto' }}
            onSubmit={handleSubmit(onSubmit)}
          >
            <div style={{marginBottom: "4px"}}>
              <Button 
                variant='contained' 
                style={{width: "50%"}} 
                color={searchMode === "serial" ? "primary" : "default"}
                onClick={() => setSearchMode("serial")}>سریال کالا</Button>
              <Button 
                variant='contained' 
                style={{width: "50%"}} 
                color={searchMode === "code" ? "primary" : "default"}
                disabled
                onClick={() => setSearchMode("code")}>کد کالا</Button>
            </div>
            <Grid
              className={classes.detail}
              container
              alignItems="center"
            >
              <Grid item xs={9} alignItems="center">
                <span style={{ margin: '0 10px' }}>
                  <Icon path={mdiBarcodeScan} size={1} color="black" />
                </span>
                {searchMode === "serial" ? <span>
                  <TextField
                    fullWidth
                    id="serial"
                    name="serial"
                    inputRef={register({
                      required: true,
                    })}
                    autoFocus
                    label="شماره سریال را وارد کنید"
                  />
                </span> : 
                <span>
                  <TextField
                    fullWidth
                    id="code"
                    name="code"
                    inputRef={register({
                      required: true,
                    })}
                    autoFocus
                    label="کد کالا را وارد کنید"
                  />
                </span>}
              </Grid>
              <Grid item xs={3}>
                <IconButton
                  aria-label="details"
                  type="submit"
                  size="small"
                  title="برداشتن آیتم"
                  data-cy="details"
                >
                  <Icon
                    path={mdiPackageVariant}
                    size={1}
                    color={theme.palette.info.main}
                  />
                </IconButton>
              </Grid>
            </Grid>
          </form>
        </Grid>
        <Grid item xs={12}>
          {loading ? (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : (
            order?.items && (
              <ListOrderItems
                data={order.items}
                setOpenUnits={handleChangeStatus}
                locateItem={id => locateItem(id)}
              />
            )
          )}
        </Grid>
      </Grid>
      <Grid xs={12} style={{ marginTop: '30px' }} container justify="flex-end">
        <Button
          aria-label="register-parcel"
          onClick={changeStatusOrder}
          color="secondary"
          variant="contained"
          disabled={
            order?.items?.filter(item => item.status !== 'PICKED').length !== 0
          }
        >
          <Icon path={mdiCheck} size={1} />
          <span style={{ paddingRight: '5px' }}>{'تایید جمع آوری سفارش'}</span>
        </Button>
      </Grid>
      <Dialog
        fullWidth
        open={openConfirmUpdateState}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleClose ? (
              <IconButton aria-label="close" onClick={handleClose}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.editIcon}>
            <Icon
              path={mdiPencilOutline}
              size={4}
              color={theme.palette.blue.main}
            />
          </div>
          <div className={classes.cancelTitle}>
            {`از تغییر تگ وضعیت سفارش
        "${translate(order.status, 'order')}"
        به
       " ${translate(previewState.replace(/"/g, '') as Status, 'order')}"
    
        
        مطمئن هستید؟`}
          </div>
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleClose}
                variant="contained"
                color="secondary"
                size="large"
              >
                {'خیر'}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                fullWidth
                variant="contained"
                onClick={changeStatusOrder}
                size="large"
              >
                {'بله'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Dialog
        fullWidth
        open={openDeleteInventoryItem}
        onClose={handleCloseDialog}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleCloseDialog ? (
              <IconButton aria-label="close" onClick={handleCloseDialog}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.cancelIcon}>
            <Icon path={mdiClose} size={4} color={theme.palette.error.main} />
          </div>
          <div className={classes.cancelTitle}>
            <div className={classes.cancelTitle}>
              {` از 
            جایگذاری آیتم انبار با سریال
          "${inventoryItem.serialNumber}"
          مطمئن هستید؟`}
            </div>
          </div>
        </DialogTitle>
        <DialogActions>
          <Grid container spacing={1}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleCloseDialog}
                variant="contained"
                color="secondary"
                size="large"
              >
                {'خیر'}
              </Button>
            </Grid>

            <Grid item xs={4}>
              <Button
                onClick={deleteInventoryItemFromOrderItem}
                fullWidth
                variant="contained"
                size="large"
              >
                {'بله'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={errorModal}
        onClose={handleCloseErrorDialog}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleCloseErrorDialog ? (
              <IconButton aria-label="close" onClick={handleCloseErrorDialog}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.cancelIcon}>
            <Icon path={mdiClose} size={4} color={theme.palette.error.main} />
          </div>
          <div className={classes.cancelTitle}>
            <div className={classes.cancelTitle}>
              {'سریال آیتم اشتباه'}
            </div>
          </div>
        </DialogTitle>
        <DialogActions>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Button
                fullWidth
                onClick={handleCloseErrorDialog}
                variant="contained"
                color="secondary"
                size="large"
              >
                {'متوجه شدم'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Modal
        onClose={handleCloseUnitModal}
        maxWidth="lg"
        open={openUnitItems}
        title={
          <div className={classes.addIcon}>
            <Icon path={mdiSelectionMarker} size={4} color="#5c5c5c" />
          </div>
        }
        content={
          <OrderItemDetail
            units={units.filter(el => el.stock > 0)}
            onClose={handleCloseUnitModal}
            orderItem={orderItem}
            pickItem={unit => pickItem(unit)}
          />
        }
      />
      <Modal
        onClose={handleClosePickModal}
        maxWidth="lg"
        open={openPickItems}
        title={
          <div className={classes.addIcon}>
            <Icon path={mdiSelectionMarker} size={4} color="#5c5c5c" />
          </div>
        }
        content={
          <OrderInventoryItems
            units={units.filter(el => el.stock > 0)}
            inventoryItems={inventoryItems}
            onClose={handleClosePickModal}
            openBarcodeScan={openBarcodeScan}
            orderItem={orderItem}
            serialNumber={serialNumber}
            openBarcode={(open: boolean) => setOpenBarcode(open)}
            updateInventoryItems={item => handleUpdateInventoryItems(item)}
            getInventoryItemsWithSerial={(serial: string) =>
              getInventoryItemsWithSerialFunc(serial)
            }
            pickOrderItem={updateOrderItems}
          />
        }
      />
    </div>
  );
}

export default Details;
